/**
 * Redemption Service
 *
 * Handles API calls for the streamer redemption shop system
 */

(function() {
  window.redemptionService = {
    /**
     * Get redemption catalog
     * @param {string} itemType - Optional filter: 'frame', 'background', 'event_card', 'subscription'
     * @returns {Promise}
     */
    getCatalog(itemType = null) {
        const url = itemType
            ? `/api/streamer/redemption/catalog.php?type=${itemType}`
            : `/api/streamer/redemption/catalog.php`;

        return axios.get(url);
    },

    /**
     * Create a redemption request (pending admin approval)
     * @param {string} catalogItemId - The catalog item ID to redeem
     * @returns {Promise}
     */
    createRedemptionRequest(catalogItemId) {
        return axios.post(`/api/streamer/redemption/redeem.php`, {
            catalog_item_id: catalogItemId
        });
    },

    /**
     * Get user's redemption requests
     * @returns {Promise}
     */
    getMyRequests() {
        return axios.get(`/api/streamer/redemption/my-requests.php`);
    },

    // ==================== ADMIN ENDPOINTS ====================

    /**
     * Get pending redemption requests (Admin only)
     * @param {string} status - Filter by status: 'pending', 'approved', 'rejected'
     * @returns {Promise}
     */
    getPendingRequests(status = 'pending') {
        return axios.get(`/api/admin/redemption/pending-requests.php?status=${status}`);
    },

    /**
     * Approve a redemption request (Admin only)
     * @param {string} requestId - The redemption request ID
     * @returns {Promise}
     */
    approveRequest(requestId) {
        return axios.post(`/api/admin/redemption/approve.php`, {
            request_id: requestId
        });
    },

    /**
     * Reject a redemption request (Admin only)
     * @param {string} requestId - The redemption request ID
     * @param {string} reason - Reason for rejection
     * @returns {Promise}
     */
    rejectRequest(requestId, reason = '') {
        return axios.post(`/api/admin/redemption/reject.php`, {
            request_id: requestId,
            reason: reason
        });
    },

    /**
     * Get redemption statistics (Admin only)
     * @returns {Promise}
     */
    getStats() {
        return axios.get(`/api/admin/redemption/stats.php`);
    },

    // ==================== CATALOG MANAGEMENT (ADMIN) ====================

    /**
     * Add catalog item (Admin only)
     * @param {Object} data - Catalog item data
     * @returns {Promise}
     */
    addCatalogItem(data) {
        return axios.post(`/api/admin/redemption/add-catalog.php`, data);
    },

    /**
     * Update catalog item (Admin only)
     * @param {Object} data - Catalog item data with id
     * @returns {Promise}
     */
    updateCatalogItem(data) {
        return axios.post(`/api/admin/redemption/update-catalog.php`, data);
    },

    /**
     * Toggle catalog item status (Admin only)
     * @param {string} id - Catalog item ID
     * @param {number} isActive - Active status (0 or 1)
     * @returns {Promise}
     */
    toggleCatalogItem(id, isActive) {
        return axios.post(`/api/admin/redemption/toggle-catalog.php`, {
            id: id,
            is_active: isActive
        });
    },

    /**
     * Delete catalog item (Admin only)
     * @param {string} id - Catalog item ID
     * @returns {Promise}
     */
    deleteCatalogItem(id) {
        return axios.post(`/api/admin/redemption/delete-catalog.php`, {
            id: id
        });
    }
  };
})();
